import React from 'react';
import PropTypes from 'prop-types';
import './_alert.scss';

const dangerIcon = (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.1129 11.9461L11.9345 13.1252L8.98788 10.1786L6.04955 13.1169L4.87121 11.9386L7.80955 9.00022L4.86371 6.05439L6.04205 4.87522L8.98788 7.82189L11.9429 4.86772L13.1212 6.04606L10.167 9.00022L13.1129 11.9461ZM14.8812 3.10772C11.6279 -0.145609 6.34871 -0.145609 3.09538 3.10772C-0.157119 6.36022 -0.157119 11.6402 3.09538 14.8927C6.34871 18.1452 11.6279 18.1452 14.8812 14.8927C18.1337 11.6402 18.1337 6.36022 14.8812 3.10772Z" fill="#B82214"/>
  </svg>
)
const warningIcon = (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.7 2.35C8.28 1.35 9.72 1.35 10.3 2.35L16.8 13.6C17.38 14.6 16.66 15.85 15.5 15.85H2.5C1.34 15.85 0.62 14.6 1.2 13.6L7.7 2.35Z" fill="var(--warning)"/>
    <path d="M9 6.25V10M9 12.5H9.0075" stroke="var(--white)" strokeWidth="1.75" strokeLinecap="round"/>
  </svg>
)
const infoIcon = (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1.5" y="1.5" width="15" height="15" rx="2" fill="var(--info)"/>
    <path d="M9 8.25V12.75M9 5.25H9.0075" stroke="var(--white)" strokeWidth="1.75" strokeLinecap="round"/>
  </svg>
)
const ALERT_ICONS = {
  danger: dangerIcon,
  warning: warningIcon,
  info: infoIcon
}
const CloseIcon = (
  <svg
  style={{ fill: '#A5A5A5' }}
  xmlns="http://www.w3.org/2000/svg"
  width="20"
  height="20"
  viewBox="0 0 20 20">
  <path
    fill="#B82214"
    d={'M15.4 4.6a.849.849 0 0 0-1.2 0L10 8.8 5.8 4.6a.849.849'+
    ' 0 1 0-1.2 1.2L8.8 10l-4.2 4.2a.849.849 0 0 0 1.2 1.2l4.2-4.2 4.2'+
    ' 4.2a.849.849 0 0 0 1.2-1.2L11.2 10l4.2-4.2a.849.849 0 0 0 0-1.2z'}/>
</svg>
)
 
function Alert({ type = 'danger', label, onClose }) {

  return label ? (
    <div role="alert" className={`alert alert--${type}`}>
      <div className='alert__icon-text-container'>
      {ALERT_ICONS[type]}
      <p className='alert__label'>{label}</p>
      </div>
      {
        onClose &&
        <button onClick={onClose} className='alert__close-button'>
             {CloseIcon}
        </button>
      }
    </div>
  ) : null;
}


Alert.propTypes = {
  type: PropTypes.oneOf(['danger', 'warning', 'info'])
};

export default Alert;
